import { forwardRef } from 'react'

import { SparkRewardsSummary } from '../../types'
import { USD_MOCK_TOKEN } from '@/domain/types/Token'
import { assets } from '@/ui/assets'
import { buttonVariants } from '@/ui/atoms/button/Button'
import { InternalLink } from '@/ui/atoms/link/Link'
import { cn } from '@/ui/utils/style'

export const TopbarSparkRewards = forwardRef<HTMLAnchorElement, SparkRewardsSummary>(({ totalUsdAmount }, ref) => {
  const className = cn(buttonVariants({ variant: 'tertiary', size: 'm', spacing: 's' }))
  return (
    <InternalLink
      variant="unstyled"
      to="/rewards"
      ref={ref}
      className={className}
      activeProps={{ className: cn(className, 'border-[#5823F3]!') }}
    >
      <img src={assets.page.sparkRewards} alt="Spark Rewards icon" className="icon-size-sm shrink-0" />
      <span className="top-bar-xl:block hidden">
        {totalUsdAmount?.gt(0) ? USD_MOCK_TOKEN.formatUSD(totalUsdAmount) : 'Rewards'}
      </span>
    </InternalLink>
  )
})
